import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { Link } from 'app/core/models/link.model';
import { SharedService } from 'app/core/services/shared.service';
import { AppStoreIcon } from '../../../../assets/icons/app-store/app-store';
import { AppStoreDarkIcon } from '../../../../assets/icons/app-store/app-store-dark';
import { GooglePlayIcon } from '../../../../assets/icons/google-play/google-play';
import { GooglePlayDarkIcon } from '../../../../assets/icons/google-play/google-play-dark';

@Component({
  selector: 'sheba-app-links',
  templateUrl: 'app-links.component.html',
  standalone: true,
  host: {
    class: 'flex flex-col gap-2'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppStoreIcon,
    AppStoreDarkIcon,
    GooglePlayIcon,
    GooglePlayDarkIcon,
    MatRippleModule,
    TranslateModule,
    RouterLinkDetectorDirective
  ]
})
export class ShebaAppLinksComponent {
  googleLink = input.required<Link>();
  appStoreLink = input.required<Link>();
  lightMode = inject(SharedService).lightMode;
}
